/**
 * Real links that still navigate inside the app (30 Sep 2026).
 *
 * Page changes used to be buttons, so Cmd/Ctrl-click, middle-click and
 * right-click → "Open in new tab" did nothing. `spaLink(href, go)` gives an
 * <a> both behaviours:
 *   plain left click       → preventDefault + go()  (in-app, no reload — as before)
 *   Cmd / Ctrl / Shift /
 *   middle / right click   → the browser's own link behaviour (new tab, menu…)
 * Either way the click stops here, so a clickable card around the link does
 * not ALSO navigate the current tab.
 */

import type { MouseEvent } from 'react'

export function isPlainClick(e: MouseEvent): boolean {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey
}

export function spaLink(href: string, go: () => void) {
  return {
    href,
    onClick: (e: MouseEvent) => {
      e.stopPropagation()
      if (e.defaultPrevented || !isPlainClick(e)) return
      e.preventDefault()
      go()
    },
  }
}

/**
 * For menu items, which cannot be real links: Cmd/Ctrl/Shift-click or a
 * middle-click opens `href` in a new tab and returns true (the caller then
 * skips its in-app navigation). A plain click returns false.
 */
export function openedInNewTab(e: MouseEvent, href: string): boolean {
  if (e.button === 2) return true            // right-click: the context menu, never a new tab
  if (isPlainClick(e)) return false
  window.open(href, '_blank', 'noopener')
  return true
}
